/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Caracteristicas_Home = ({titulo, parrafo, icono}) => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'flex-between'}
            alignItems={'flex-start'}
            size={12}
        >

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <Grid2
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}>


                    <Grid2 container size={2}>
                        <img src={icono} width={'80%'} height={'auto'}/>
                    </Grid2>

                    <Grid2 container size={8} sx={{mt: 2}}>
                        <Typography sx={{fontSize: sCell ? 20 : 30, fontWeight: 800, lineHeight: 1.1}}>
                            {titulo}
                        </Typography>
                    </Grid2>


                </Grid2>
            </Grid2>


            <Grid2 container size={12}>
                <Typography sx={{
                    fontSize: sCell ? 16 : 20,
                    height: {sx: 230, sm: 280, md: 130},
                    lineHeight: 1.4,
                    pt: 2
                }}>
                    {parrafo}
                </Typography>

            </Grid2>


            <Grid2 container size={{xs: 2, sm: 12, md: 2}}
                   sx={{pr: 20, pt: 4, borderBottom: `6px solid ${theme.palette.primary.main}`}}>

            </Grid2>
        </Grid2>
    )

}
export default Tarjeta_Caracteristicas_Home